<template>
  <transition name="modal">
    <div class="modal-mask" @mousedown="dontClose">
      <div class="modal-wrapper grayBackground">
        <div class="modal-container modal-container-40">
          <div class="modal-body m-0" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" @keyup.enter="quickChangePassword()">
              <b-row class="panel-heading">
                <b-col cols="10" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-lock mr-2" style="font-size: 20px"></i>
                    {{ $t('administration.renew_password') }}
                  </h4>
                </b-col>
                <b-col cols="2">
                  <b-dropdown left toggle-class="border-0 p-0 bg-none m-md-2 text-dark" v-model="language">
                    <template slot="button-content">
                      <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" /><span class="d-none-max-1459px mr-1">{{ labelLanguage }}</span>
                    </template>
                    <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                      <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR"/>
                      <img class="flag-nav" v-else :src="logoFlagEN"/>
                      <span>{{option.text}}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label>{{$t('common.orig_pwd')}} <span class="color-red">*</span></label>
                    <div class="d-flex">
                      <input v-model="originalPassword"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="originalPasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isOriginalPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleOriginalPasswordVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label>{{$t('common.new_pwd')}} <span class="color-red">*</span></label>
                    <div class="d-flex">
                      <input v-model="newPassword"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="newPasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleNewPasswordVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label>{{$t('common.new_pwd')}} <span class="color-red">*</span></label>
                    <div class="d-flex">
                      <input v-model="confirmNewPassword"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="confirmNewPasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isConfirmNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleConfirmNewPasswordVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>

            </div>
          </div>
          <div class="modal-footer">
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 mr-2">
              <b-button variant="primary"
                @click="changePassword">
                {{ $t('common.sve') }}
              </b-button>
            </b-col>
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 m-0">
              <b-button variant="primary"
                @click="logout">
                {{ $t('leftPanelTitle.lgout') }}
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'

import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'ChangePasswordPopup',
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      mousedown: false,
      reasonLabel: '',
      originalPassword: '',
      originalPasswordFieldType: 'password',
      newPassword: '',
      newPasswordFieldType: 'password',
      confirmNewPassword: '',
      confirmNewPasswordFieldType: 'password',
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
    this.language = this.$i18n.locale.toUpperCase()
    this.langOptions = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  computed: {
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].value
      }
      return label
    },
    isConfirmNewPasswordFieldHidden () {
      return this.confirmNewPasswordFieldType === 'password'
    },
    isNewPasswordFieldHidden () {
      return this.newPasswordFieldType === 'password'
    },
    isOriginalPasswordFieldHidden () {
      return this.originalPasswordFieldType === 'password'
    }
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
        document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: maxHeight' + 'px')
    },
    changePassword () {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (that.originalPassword === '' && this.$engine.user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert(that.$i18n.t('profilesPage.password_original_missing'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.new_pwd_mssng'), that.$i18n.t('common.error_title'))
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.cnfrm_pwd'), that.$i18n.t('common.error_title'))
      } else if (!regexPassword.test(that.newPassword)) {
        that.$f7.alert(that.$i18n.t('profilesPage.password_wrong_format'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert(that.$i18n.t('common.security.passwords_not_matching'), that.$i18n.t('common.error_title'))
      } else if (that.originalPassword === that.newPassword) {
        that.$f7.alert(that.$i18n.t('common.security.password_same'), that.$i18n.t('common.error_title'))
      } else {
        var connectBy = 'lpc'
        this.changePasswordAPI(connectBy)
      }
    },
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.user.setIsFirstLogin('0')
          this.$engine.user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: this.$t('common.security.password_modified'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.$emit('close')
          }, 2000)
        }
      })
      .catch(error => {
        if (error.response.data.error === 'oldPassword not valid') {
          that.$f7.modal({
          title: that.$t('profilesPage.password_old_not_valid'),
          text: error.response.data.errorDescription,
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
        } else {
          if (error && error.response && error.response.data && error.response.data.error && that.$t('errors._specific.title.' + error.response.data.error) !== 'errors._specific.title.' + error.response.data.error) {
            error.response.data.error = that.$t('errors._specific.title.' + error.response.data.error)
          }
          errorMessageAlert(error, that)
        }
      })
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.langOptions = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    logout () {
      this.$bus.emit('logout')
      this.$f7.closeModal()
      this.$emit('close')
    },
    quickChangePassword() {
      if (this.originalPassword.length !== 0 && this.newPassword.length !== 0 && this.confirmNewPassword.length !== 0 && !this.$$('.modal-in').length) {
        this.changePassword()
      }
    },
    toggleConfirmNewPasswordVisibility () {
      if (this.confirmNewPasswordFieldType === 'password') {
        this.confirmNewPasswordFieldType = 'text'
      } else {
        this.confirmNewPasswordFieldType = 'password'
      }
    },
    toggleNewPasswordVisibility () {
      if (this.newPasswordFieldType === 'password') {
        this.newPasswordFieldType = 'text'
      } else {
        this.newPasswordFieldType = 'password'
      }
    },
    toggleOriginalPasswordVisibility () {
      if (this.originalPasswordFieldType === 'password') {
        this.originalPasswordFieldType = 'text'
      } else {
        this.originalPasswordFieldType = 'password'
      }
    }
  }
}

</script>
